import { createContext } from "react";

interface BankConnectConsentProps {
  consentHandler: () => Promise<void>;
  consentNeeded: boolean;
}

export interface BankConnectConsentProviderProps extends BankConnectConsentProps {
  children: React.ReactNode;
}

export type BankConnectContextValue = {
  openBankConnectConsentModal: (providerName: string, onConsentGiven: () => void) => void;
  bankConnectConsentNeeded: boolean;
  modalOpen: boolean;
};

export const BankConnectConsentContext = createContext<BankConnectContextValue>({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  openBankConnectConsentModal: (providerName: string, onConsentGiven: () => void) => {},
  // default to false for safety reasons.
  // In case of a bug where the bank connect consent hook
  // was used without the context being set up properly
  bankConnectConsentNeeded: false,
  modalOpen: false,
});
